import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MoteService } from '../../../providers';
import { Mote } from '../../../models';

@Component({
    selector: 'auto-complete-mote-children',
    templateUrl: './auto-complete-mote-children.component.html',
    styleUrls: ['./auto-complete-mote-children.component.css']
})
export class AutoCompleteMoteChildrenComponent {

    @Output() selectedMotesChanged = new EventEmitter<Mote[]>();
    @Input() set initSelectedMotes(motes: Array<Mote>) {
        // Init mote list with motes already in list (OBS this will happen every time an change is emitted)
        // Make of slice copy of array (otherwise functions like pop() will change the original array)
        this.selectedMotes = motes.slice(0);
    }

    @Input() set parentMote(parentMote: Mote) {
        if(!parentMote) return;
        // Get observable of mote items to be used in owner list
        this.motesObservable = this.moteService.watchProjectMotes([parentMote.project]);
        this.parent = parentMote;
    }

    // List of mote children
    public selectedMotes: Array<Mote> = [];
    // Observable to be used in autocompletion list
    public motesObservable;
    // Filter function to select motes
    public filterFunction;
    public parent;

    constructor(private moteService: MoteService) {
        // Wrap filter function in ES6 container in order to preserve conrext
        this.filterFunction = (mote, idx, searchString) => this.filterMotes(mote, idx, searchString);
    }

    public moteSelected(mote: Mote) {
        this.selectedMotes.push(mote);
        this.selectedMotesChanged.emit(this.selectedMotes);
    }

    public moteUnselected(rmMote: Mote) {
        this.selectedMotes = this.selectedMotes.filter((mote: Mote) => {
            // Remove mote from list (return false if this is the one to be remove)
            return !(mote.key == rmMote.key);
        });
        this.selectedMotesChanged.emit(this.selectedMotes);
    }

    public queryDeleted() {
        if(this.selectedMotes.length <= 0) return;
        // Delete last entry in list of owners
        this.selectedMotes.pop();
        this.selectedMotesChanged.emit(this.selectedMotes);
    }

    public filterMotes(mote: Mote, idx: number, searchString: string): boolean {
        // List must not contain more than 100 motes (TODO: look at length instead of idx)
        if(!searchString || idx >= 100) return false;

        // Filter away the parent mote
        if(!this.parent || mote.key == this.parent.key) return false;

        // Filter away motes that are already children of this mote
        if(this.selectedMotes.find((searchMote) => searchMote.key == mote.key)) return false;

        if(searchString == "*") return true;

        // Search without case sensitivity
        let query = searchString.toLocaleLowerCase();
        // Test of queryuery has wildcard character at beginning
        let wildcard = query.startsWith("*")
        query = query.replace("\*", "");

        // Search for string matches (by default only from beginning of string)
        if(wildcard)
            return mote.title.toLowerCase().includes(query);
        else
            return mote.title.toLowerCase().startsWith(query);
    }
}
